/* The revision check behind a checked save (lib/dataService.js saveChecked and the test
   fake, src/test/fakeFirestore.js). `expected` is { exists, savedAt }: what the caller
   loaded. No imports, so the fake doesn't pull in the Firebase SDK. */
const isPlainObject = (v) => v && typeof v === "object" && !Array.isArray(v);

/** Firestore's merge rule (setDoc with merge: true), so a checked save can hand back the
 *  document as committed and the test fake stores what Firestore would: nested maps merge,
 *  an EMPTY map replaces the whole field (Firestore's SetOptions: "if your input sets any
 *  field to an empty map, all nested fields are overwritten"), everything else replaces,
 *  undefined is dropped. */
export function mergeDoc(target, source) {
  const out = isPlainObject(target) ? { ...target } : {};
  for (const [k, v] of Object.entries(source || {})) {
    if (v === undefined) continue;
    if (isPlainObject(v) && isPlainObject(out[k]) && Object.keys(v).length) out[k] = mergeDoc(out[k], v);
    else out[k] = v === null ? null : JSON.parse(JSON.stringify(v));
  }
  return out;
}

export function checkRevision(exists, storedSavedAt, expected) {
  if (!expected) return;
  if (expected.exists && !exists) {
    const err = new Error("This record was deleted elsewhere since it was opened.");
    err.code = "deleted-elsewhere";
    throw err;
  }
  if (!expected.exists && exists) {
    const err = new Error("This record was created elsewhere since it was opened.");
    err.code = "changed-elsewhere";
    err.currentSavedAt = storedSavedAt ?? null;
    throw err;
  }
  if (exists && (storedSavedAt ?? null) !== (expected.savedAt ?? null)) {
    const err = new Error("This record was saved elsewhere since it was opened.");
    err.code = "changed-elsewhere";
    err.currentSavedAt = storedSavedAt ?? null;
    throw err;
  }
}
